<template>
  <div class="partner-message">
    <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">添加</el-button>
    <el-form class="form" v-for="(item,index) in list" :key="index" label-width="80px">
      <el-form-item label="合作方">
        <el-select v-model="item.partner_id" clearable filterable placeholder="请选择">
          <el-option v-for="part in partner" :key="part.id" :label="part.title" :value="part.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="轮播资讯">
        <div class="swiper" v-for="(swiper,idx) in item.swiper" :key="idx">
          <el-select v-model="swiper.type" clearable placeholder="请选择类型" @change="typeChange(index, idx)" style="margin-right:10px;">
            <!-- <el-option value="sc_pr" label="放映项目"></el-option> -->
            <el-option value="track" label="展映"></el-option>
            <el-option value="discussion" label="专访"></el-option>
            <el-option value="interview" label="采访对谈"></el-option>
            <el-option value="movie" label="电影"></el-option>
          </el-select>
          <el-select v-model="swiper.id" clearable filterable v-if="swiper.type==='sc_pr'" placeholder="请选择放映项目">
            <el-option v-for="swiper in options1" :key="swiper.id" :label="swiper.title" :value="swiper.id">
            </el-option>
          </el-select>
          <el-select v-model="swiper.id" clearable filterable v-else-if="swiper.type==='track'" placeholder="请选择展映">
            <el-option v-for="swiper in trackOptions" :key="swiper.id" :label="swiper.title" :value="swiper.id">
            </el-option>
          </el-select>
          <el-select v-model="swiper.id" clearable filterable v-else-if="swiper.type==='interview'" placeholder="请选择采访对谈">
            <el-option v-for="swiper in options2" :key="swiper.id" :label="swiper.title" :value="swiper.id">
            </el-option>
          </el-select>
          <el-select v-model="swiper.id" clearable filterable v-else-if="swiper.type==='discussion'" placeholder="请选择对谈">
            <el-option v-for="swiper in discussionOptions" :key="swiper.id" :label="swiper.title" :value="swiper.id">
            </el-option>
          </el-select>

          <SelectMovie v-model="swiper.id" :list="movieOptions" v-else-if="swiper.type==='movie'" ></SelectMovie>
          <!-- <el-select v-model="swiper.id" clearable v-else-if="swiper.type==='movie'" placeholder="请选择电影">
            <el-option v-for="movie in movieOptions" v-if="movie.partner_id == item.partner_id" :key="movie.id" :label="movie.title"
              :value="movie.id">
            </el-option>
          </el-select> -->
          <el-button type="text" @click="deleteSwiper(index, idx)" size="mini" style="margin-left:10px;">删除</el-button>
          <el-button type="text" @click="handleplus(index, idx)" size="mini" style="margin-left:10px;">向上添加</el-button>
          <el-button type="text" @click="handleplus(index,  idx+1)" size="mini" style="margin-left:10px;">向下添加</el-button>
        </div>
        <!-- <el-button size="mini" @click="handleplus(index)">+ 添加</el-button> -->
      </el-form-item>
      <el-form-item>
        <el-button type="text" @click="deleteItem(index)" size="small">删除</el-button>
        <el-button type="text" size="mini" @click="handleUp(index)">上移</el-button>
        <el-button type="text" size="mini" @click="handleDown(index)">下移</el-button>
        <el-button type="text" size="mini" @click="handleCreate(index)">向上添加</el-button>
        <el-button type="text" size="mini" @click="handleCreate(index+1)">向下添加</el-button>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="handleSubmit">保 存</el-button>
    <upload-img ref="upload" tips-width="900" tips-height="900"></upload-img>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import UploadImg from '@/components/UploadImg'
  import SelectMovie from '@/components/SelectMovie/index.vue'
  export default {
    name: 'partnerMessage',
    components: {
      UploadImg,
      SelectMovie
    },
    data() {
      return {
        list: [],
        partner: [],
        options1: [],
        options2: [],
        trackOptions: [],
        discussionOptions: [],
        movieOptions: []
      }
    },
    created() {
      this.getList()
      this.getPartner()
      this.getDiscussion()
      this.getTalk()
      this.getTrackList()
      this.getDiscussionList()
      this.getMovieList()
    },
    methods: {
      handleUp(index) {
        if (index === 0) return
        let current = JSON.parse(JSON.stringify(this.list[index]))
        let pre = JSON.parse(JSON.stringify(this.list[index - 1]))
        this.list.splice(index, 1, pre)
        this.list.splice(index - 1, 1, current)
      },
      handleDown(index) {
        if (index === this.list.length - 1) return
        let current = JSON.parse(JSON.stringify(this.list[index]))
        let next = JSON.parse(JSON.stringify(this.list[index + 1]))
        this.list.splice(index, 1, next)
        this.list.splice(index + 1, 1, current)
      },
      deleteItem(index) {
        this.list.splice(index, 1)
      },
      deleteSwiper(index, idx) {
        this.list[index].swiper.splice(idx, 1)
      },
      typeChange(index, idx) {
        this.list[index].swiper[idx].id = ''
      },
      handleplus(index, idx) {

        // idx = idxthis.list[index].swiper.length

        this.list[index].swiper.splice(idx, 0, {
          type: '',
          id: ''
        })
        // this.list[index].swiper.push({
        //   type: '',
        //   id: ''
        // })
      },
      handleCreate(index) {
        index = index || 0
        this.list.splice(index, 0, {
          partner_id: '',
          swiper: [{
            type: '',
            id: ''
          }]
        })
      },
      handleSubmit() {
        request({
          url: '/partner-message',
          method: 'put',
          data: {
            partner_message: this.list
          }
        }).then(res => {
          this.$message.success('保存成功!')
        })
      },
      getList() {
        request({
          url: '/partner-message'
        }).then(res => {
          this.list = res.data.content || []
        })
      },
      getPartner() {
        request({
          url: '/partners'
        }).then(res => {
          this.partner = res.data.list
        })
      },
      getDiscussion() {
        request({
          url: '/screening-programs'
        }).then(res => {
          this.options1 = res.data.list
        })
      },
      getTalk() {
        request({
          url: '/interviews'
        }).then(res => {
          this.options2 = res.data.list
        })
      },
      getDiscussionList() {
        request({
          url: '/movie/articles',
          params: {
            type: 'discussion',
            per_page: 100
          }
        }).then(res => {
          this.discussionOptions = res.data.list
        })
      },
      getTrackList() {
        request({
          url: '/movie/articles',
          params: {
            type: 'movie_panorama',
            per_page: 100
          }
        }).then(res => {
          this.trackOptions = res.data.list
        })
      },
      getMovieList() {
        request({
          url: '/movie-simple-list',
          params: {
            per_page: 1000
          }
        }).then(res => {
          this.movieOptions = res.data.list
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .form {
    width: 700px;
    background-color: #f5f5f5;
    padding: 10px;
    margin: 10px 0;

    /deep/ .el-form-item {
      margin-bottom: 10px;
    }

    .swiper {
      display: flex;
      margin-bottom: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/movie/partnerMessage.vue